// extracted by mini-css-extract-plugin
export default {"control":"Control_control__olJAF","grid":"Control_grid__T8Rea","autobet":"Control_autobet__5LvkF","checkbox":"Control_checkbox__RdZgq"};